import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import jsPDF from 'jspdf';
import {Button, Row, message, Col, Select, Form,Progress,Tooltip,Menu,Icon,Dropdown, Modal} from 'antd';
import * as etiquetas from '../../ApplicationResources';
import flecha2 from '../../img/flecha2.png';
import flecha3 from '../../img/flecha3.png';
import flecha4 from '../../img/flecha4.png';
import flecha5 from '../../img/flecha5.png';
import flecha6 from '../../img/flecha6.png';
import * as html2canvas from 'html2canvas';
import BlockLoader from '../interfaz/Loader.js';
import errorImgModal from '../../img/error_icon.svg';
import '../../css/filtro.css';
import '../../css/graficas.css';
import {withRouter} from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { selectProceso, selectEstado, selectDistrito } from '../../redux/menu/menu-selectors';
import { selectCurrentUser, selectCurrentUserRol } from '../../redux/user/user-selectors';
import Mapa from './Mapa';
import { verifiedToken } from '../../utils/funciones.js';

let msjError = "";
const newDate = new Date();
const fechaActual = newDate.getDate()+"/"+(newDate.getMonth() + 1)+"/"+ newDate.getFullYear()+
                    "  "+newDate.getHours()+":"+newDate.getMinutes()+" hrs";
const imgData =  "data:image/png;base64,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";

let entidad = "";
let mostrar = false;

class Filtros extends Component {

  constructor(props) {
    super(props);

    this.state = {
      msjError : "",
      abrirModalError : false,
      infoGrafica : null,
      mostrarBarchart :false,
      totalRegLinea : 0,
      porcRegLinea : 0,
      totalRegJd : 0,
      porcRegJd : 0,
      totalAspirantes : 0,
      collapsed: false,
      totalAspDocPorApro : 0,
      porcAspDocPorApro : 0,
      totalAspDocAprobados : 0,
      porcAspDocAprobados : 0,
      totalRegDeclinados : 0,
      porcRegDeclinados : 0,
      totalAspirantes : 0,
      totalAspirantesSinValiCorreo : 0,
      porcAspirantesSinValiCorreo: 0,
      totalAspirantesSinPlatica: 0,
      porcAspSinPlatica: 0,
      totalAspirantesConPlatica: 0,
      porcAspConPlatica: 0,
      totalAspAcudenJDE: 0,
      porcAspAcudenJDE: 0,
      totalAspObs: 0,
      porcAspObs: 0,
      totalAspSinDocs: 0,
      porcSinDocs: 0,
      totalaspirantesvalidados:0,
      porcaspirantesvalidados:0,
      totalevalcurri:0,
      porcevalcurri:0,
      totalevalint:0,
      porcevalint:0,
      totalaspfinal:0,
      porcaspfinal:0,
      loader : false,
      actividades: [
        {
           "fechaActividad": "",
           "nombreActividad": "",
           "fechaActividadFin":"",
           "periodo": ""
         },
         {
           "fechaActividad": "",
           "nombreActividad": "",
           "fechaActividadFin":"",
           "periodo": ""
         },
         {
           "fechaActividad": "",
           "nombreActividad": "",
           "fechaActividadFin":"",
           "periodo": ""
         },
         {
           "fechaActividad": "",
           "nombreActividad": "",
           "fechaActividadFin":"",
           "periodo": ""
         },
         {
           "fechaActividad": "",
           "nombreActividad": "",
           "fechaActividadFin":"",
           "periodo": ""
         }
      ]
    };


  }

  cerrarErrorModal(){
    this.setState({abrirModalError:false});
  }

  /**
  * Muestra los mensajes de error
  **/
  mostrarError(error){
    if (error.response){
        if (error.response.status === 409){
            msjError = error.response.data.message;
        } else if (error.response.data && error.response.data.causa
            && error.response.data.causa.includes("Error de validación")){
            msjError = error.response.data.message;
        } else if (error.response && error.response.status === 500){
            msjError = error.response.data.message;
        } else {
            msjError = etiquetas.gral_error_cau;
        }
    } else {
        msjError = etiquetas.gral_error_cau;
    }
    this.setState({
      msjError : msjError,
      abrirModalError : true
    });
  }

  componentDidUpdate(prevProps){
    // Comparamos si el usuario ha seleccionado otro estado, proceso, distrito para volver a cargar la gráfica y actividades
    if(this.props.proceso !== prevProps.proceso
      || this.props.estado !== prevProps.estado
      || this.props.distrito !== prevProps.distrito){
        this.handleCrearGrafica();
        this.obtenerActividades();

        return;
      }
  }

  componentWillMount() {
    //this.setState({mostrarBarchart:props.mostrarBarchart});
    this.handleCrearGrafica();
    this.obtenerActividades();
  }

  menu = ()=>{
    return(
      <Menu>
        <Menu.Item key="1" onClick={e=>this.generarPdf()}>
          <Icon type="file-pdf"/>PDF
        </Menu.Item>
        <Menu.Item key="2"  onClick={e=>this.generarExcel()}>
             <Icon type="file-excel" />Excel
        </Menu.Item>
      </Menu>
    );
  }

  menuBitacoras = ()=>{
    return(
      <Menu>
        <Menu.Item key="1" onClick={e=>this.generarExcelBitacoraMod()}>
          <Icon type="file-excel"/>Módulos
        </Menu.Item>
        <Menu.Item key="2"  onClick={e=>this.generarExcelBitacoraRep()}>
             <Icon type="file-excel" />Reportes
        </Menu.Item>
      </Menu>
    );
  }

  generarExcel(){
    const { estado, proceso, distrito } = this.props;

    let hd = { 'Accept': 'application/json','Content-Type': 'application/json'};
    
    const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
    const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
    const idEstado = estado ? estado.idEstado : 0;
    const idDistrito = distrito ? distrito.idDistrito : 0;

    var datos = {
			idProcesoElectoral : idProcesoElectoral,
			idDetalleProceso : idDetalleProceso,
      idEstado: idEstado,
      idDistrito: idDistrito
		};

    hd = verifiedToken(hd);

    if(idProcesoElectoral > 0 && idDetalleProceso > 0 && idEstado > 0) {
      this.setState({loader:true})
      axios.post(process.env.REACT_APP_API_URL +
        "/ws_reclutaseycae_central/ws/obtenerExcelAspirantes", datos,
            {
              responseType: 'blob',
              transformResponse: [ data => {
              let blob = new window.Blob([data], {type: "application/vnd.ms-excel"});
              var link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.setAttribute('download', `avance_reclutamiento_se_cae.xlsx`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link)
              }],
              headers:hd
            }
         ).then(response => {
           console.log("respuesta...",response);
           this.setState({loader:false})
      }).catch(error => {
        console.error("Error al generar el excel "+
            "generalExcel()",error);
        this.setState({loader:false})
        this.mostrarError(error);
      });
    }
  }

  generarExcelBitacoraMod = () => {
    const { estado, proceso, distrito, user } = this.props;

    let hd = { 'Accept': 'application/json','Content-Type': 'application/json'};
    hd = verifiedToken(hd);
    
    const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
    const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
    const idEstado = estado ? estado.idEstado : 0;
    const idDistrito = distrito ? distrito.idDistrito : 0;

    var datos = {
			idProcesoElectoral : idProcesoElectoral,
			idDetalleProceso : idDetalleProceso,
      idSistema : etiquetas.idSistema,
      idEstado: idEstado,
      idDistrito: idDistrito,
      usuario : user.username
		};

    this.setState({loader:true})
    axios.post(process.env.REACT_APP_API_URL +
      "/ws_reclutaseycae_central/ws/obtenerExcelBitacoraMod", datos,
          {
            responseType: 'blob',
            transformResponse: [ data => {
            let blob = new window.Blob([data], {type: "application/vnd.ms-excel"});
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', `bitacora.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link)
            }],
            headers:hd
          }
       ).then(response => {
         this.setState({loader:false})
    }).catch(error => {
      console.error("Error al generar el excel "+
          "generalExcel()",error);
      this.setState({loader:false})
      this.mostrarError(error);
    });
  }

  generarExcelBitacoraRep = () => {
    const { estado, proceso, distrito, user } = this.props;

    let hd = { 'Accept': 'application/json','Content-Type': 'application/json'};
    hd = verifiedToken(hd);
    
    const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
    const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
    const idEstado = estado ? estado.idEstado : 0;
    const idDistrito = distrito ? distrito.idDistrito : 0;

    var datos = {
			idProcesoElectoral : idProcesoElectoral,
			idDetalleProceso : idDetalleProceso,
      idSistema : etiquetas.idSistema,
      idEstado: idEstado,
      idDistrito: idDistrito,
      usuario : user.username
		};

    this.setState({loader:true})
    axios.post(process.env.REACT_APP_API_URL +
      "/ws_reclutaseycae_central/ws/obtenerExcelBitacoraRep", datos,
          {
            responseType: 'blob',
            transformResponse: [ data => {
            let blob = new window.Blob([data], {type: "application/vnd.ms-excel"});
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', `bitacora_reportes.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link)
            }],
            headers:hd
          }
       ).then(response => {
         this.setState({loader:false})
    }).catch(error => {
      console.error("Error al generar el excel "+
          "generalExcel()",error);
      this.setState({loader:false})
      this.mostrarError(error);
    });
  }

  generarPdf(){
    const { proceso } = this.props;
    this.setState({loader:true})
    var doc = new jsPDF({
      orientation: 'landscape',
    });
    //var width   = doc.internal.pageSize.getWidth();
    //var height  = doc.internal.pageSize.getHeight();

    doc.setFontStyle('normal');
    doc.setFontSize(10);
    doc.text(200,20,'Fecha de corte: '+ fechaActual);
    doc.text(200,25,'Proceso Electoral: '+ proceso.descripcionDetalleLarga);
    // move_from_left, move_from_height, width, height
    doc.addImage(imgData, 'JPEG', 10, 10, 30, 16);
    doc.setFontSize(14);
    doc.setFontStyle('bold');
    // move_from_left, move_from_height
    doc.text(100, 35, 'Avance de Reclutamiento para SE y CAE')

    this.generarPdfJd(doc)


  }

  obtenerEscala(){
    var srcwidth = document.getElementById('toPDF').scrollWidth;
    var escala =  Math.trunc(srcwidth / 1000);

    return escala;
  }

  generarPdfJd(doc){
    window.scrollTo(0, 0);
    var total = document.getElementById("barra-totales");
    var barraIzq = document.getElementById("circulo-izq");
    var barraDer = document.getElementById("circulo-der");
    var barras = document.getElementById("bars-mov");
    var circuloDer = "";
    var circuloIzq = "";
    var barraTotal = "";
    var graficaBarras = "";
    var escala = this.obtenerEscala();
    var escalaBarra = escala > 4 ? .7 : 1;
    html2canvas(total,{
      height: 450,
      scale: 1
    }).then(canvas=>{
      barraTotal = canvas.toDataURL('image/png');
      html2canvas(barraIzq, {
        scale: .92
        })
          .then(canvas => {
            circuloIzq = canvas.toDataURL('image/png');
            html2canvas(barraDer,{
              scale: .92
            }).then(canvas=>{
              circuloDer = canvas.toDataURL('image/png');
              html2canvas(barras,{
                scrollX: -window.scrollX,
                scrollY: -window.scrollY,
                windowWidth: document.documentElement.offsetWidth,
                scale: escalaBarra
              }).then(canvas=>{
                graficaBarras = canvas.toDataURL('image/png');
                doc.addImage(barraTotal, 'PNG', -10, 30,300,120);
                doc.addImage(circuloIzq, 'PNG', 0, 70,140,100);
                doc.addImage(circuloDer, 'PNG', 130, 70,140,100);
                doc.setFontSize(12);
                doc.setFontStyle("normal");
                doc.text(30, 175, 'Aspirantes registrados en Línea: ');
                doc.text(100, 175, ""+this.state.totalRegLinea);
                doc.text(160, 175, 'Aspirantes registrados en JDE: ');
                doc.text(230, 175, ""+this.state.totalRegJd);
                doc.addPage();//aqui hago un salto de pagina, una imagen en cada pagina
                doc.addImage(imgData, 'JPEG', 10, 10, 30, 16);

                doc.addImage(graficaBarras, 'PNG', 10, 30,);
                doc.text(190, 40, 'Desglose de la información');
                doc.setFontSize(12);
                doc.setFontStyle("normal");
                doc.text(170, 50, 'Aspirantes registrados: ');
                doc.text(270, 50, ""+this.state.totalAspirantes);
                doc.text(170, 100, 'Aspirantes sin validar correo: ');
                doc.text(270, 100, ""+this.state.totalAspirantesSinValiCorreo);
                doc.text(170, 90, 'Aspirantes sin documentos, con correo validado y');
                doc.text(170, 95, 'que no acuden a la JDE: ');
                doc.text(270, 95, ""+this.state.totalAspSinDocs);
                doc.text(170, 75, 'Aspirantes que acuden a la JDE: ');
                doc.text(270, 75, ""+this.state.totalAspAcudenJDE);
                doc.text(170, 80, 'Aspirantes con documentos adjuntos por validar: ');
                doc.text(270, 80, ""+this.state.totalAspDocPorApro);
                doc.text(170, 85, 'Aspirantes con documentos con observaciones: ');
                doc.text(270, 85, ""+this.state.totalAspObs);
                doc.text(170, 70, 'Aspirantes declinados: ');
                doc.text(270, 70, ""+this.state.totalRegDeclinados);
                doc.text(170, 65, 'Aspirantes finalizados sin cápsula de inducción: ');
                doc.text(270, 65, ""+this.state.totalAspirantesSinPlatica);
                doc.text(170, 60, 'Aspirantes finalizados con cápsula de inducción: ');
                doc.text(270, 60, ""+this.state.totalAspirantesConPlatica);

                doc.setFontSize(12);
                doc.text(20, 170, 'Fases del proceso');
                doc.setFontSize(9);
                doc.text(20, 180, '1. Con informacion de la solicitud : Realizaron el registro y está pendiente subir los documentos.');
                doc.text(20, 185, '2. Con documentos adjuntos por aprobar: Concluido el registro, han subido los documentos y están en espera de validación por la Junta Distrital.');
                doc.text(20, 190, '3. Con documentos adjuntos aprobados: la Junta Distrital validó y aprobó los documentos subido.');
                doc.text(20, 195, '4. Declinados: la Junta Distrital validó y declinó al aspirante.');
                // Save the Data
                doc.save('avanceReclutamiento_SE_CAE.pdf');
                this.setState({loader:false});
              })

            });
          });
    });
  }

  /**
  * Obtiene los valores para crear la grafica de acuerdo con el proceso, entidad y distrito seleccionados
  **/
  handleCrearGrafica = () => {
    // Obtenemos los datos de propiedad de mapStateToProps
    const { estado, proceso, distrito, user } = this.props;

    const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
    const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
    var idEstado = estado ? estado.idEstado : 0;
    var idDistrito = distrito ? distrito.idDistrito : 0;

    // Si es un JD, usamos el idDistrito que trae el usuario
    if(user.idDistrito > 0)
      idDistrito = user.idDistrito;

    // Si es un JL, usamos el idEstado que trae el usuario
    if(user.idEstado > 0)
      idEstado = user.idEstado;

    this.limpiarInfo();

    const cadenaDistrito = distrito && distrito.idDistrito > 0 ? "JDE " + distrito.idDistrito + " " : "";
    entidad = estado && estado.idEstado > 0 ? cadenaDistrito + estado.nombreEstado : "";
    
    this.props.infoGrafica(idProcesoElectoral, idDetalleProceso, idEstado, idDistrito)
    .then(datosGrafica => {
        this.setState({infoGrafica:datosGrafica});
        this.acomodarInfo(datosGrafica);
    }).catch(error => {
      console.error("Error al obtener los datos para las gráficas "+
          "handleCrearGrafica()",error);
      this.mostrarError(error);
    });
  }

  /**
   * Función que consulta las actividades en la tabla C_ACTVIDIDADES, definidas por idProcesoElectoral y idDetalleProceso
   */
  obtenerActividades(){
    const { proceso } = this.props;

    const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
    const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;

    var postData = {
      idProcesoElectoral : idProcesoElectoral,
      idDetalleProceso : idDetalleProceso
    }

    if(idProcesoElectoral > 0 && idDetalleProceso > 0) {
      // Consultamos las actividades del proceso seleccionado
      axios.post(process.env.REACT_APP_API_URL +
        "/ws_reclutaseycae_central/ws/obtenerActividades", postData,
            {
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization': localStorage.getItem("jwt-token") 
                }
            }
         ).then(response => {
           if(response.data.length > 0){
              this.setState({
                actividades:response.data
              });
           } else {
            this.setState({
              actividades:null
            });
           }
      }).catch(error => {
        console.error("Error al consultar las actividades "+
            "obtenerActividades()",error);
        this.mostrarError(error);
      });
    } else {
      // Limpiamos las actividades
      this.setState({
        actividades:null
      });
    }
  }

  acomodarInfo = (info) => {
    if(info !== undefined && info !== null){
      this.setState({
        totalAspirantes : info.totalAspirantes,
        totalRegLinea : info.totalRegistroLinea,
        porcRegLinea : info.porcRegistroLinea,
        totalRegJd : info.totalRegistrosJD,
        porcRegJd : info.porcRegistrosJD,
        totalAspirantesSinPlatica : info.totalAspirantesSinPlatica,
        porcAspSinPlatica : info.porcAspSinPlatica,
        totalAspirantesConPlatica : info.totalAspirantesConPlatica,
        porcAspConPlatica : info.porcAspConPlatica,
        totalRegDeclinados : info.totalRegDeclinados,
        porcRegDeclinados : info.porcRegDeclinados,
        totalAspAcudenJDE : info.totalAspAcudenJDE,
        porcAspAcudenJDE : info.porcAspAcudenJDE,
        totalAspDocPorApro : info.totalAspDocPorApro,
        porcAspDocPorApro : info.porcAspDocPorApro,
        totalAspObs : info.totalAspObs,
        porcAspObs : info.porcAspObs,
        totalAspSinDocs : info.totalAspSinDocs,
        porcSinDocs : info.porcSinDocs,
        totalAspirantesSinValiCorreo : info.totalAspirantesSinValiCorreo,
        porcAspirantesSinValiCorreo : info.porcAspirantesSinValiCorreo,
        totalaspirantesvalidados:info.totalAspirantesValidados,
        porcaspirantesvalidados:info.porcAspirantesValidados,
        totalevalcurri:info.totalEvalCurri,
        porcevalcurri:info.porcEvalCurri,
        totalevalint:info.totalEvalInt,
        porcevalint:info.porcEvalInt,
        totalaspfinal:info.totalAspFinal,
        porcaspfinal:info.porcAspFinal
      });
    } else {
      this.limpiarInfo();
    }
  }

  limpiarInfo = () => {
    this.setState({
      totalRegLinea:0,
      porcRegLinea : 0,
      totalRegJd : 0,
      porcRegJd : 0,
      totalAspDocPorApro : 0,
      porcAspDocPorApro : 0,
      totalAspDocAprobados : 0,
      porcAspDocAprobados : 0,
      totalRegDeclinados : 0,
      porcRegDeclinados : 0,
      totalAspirantes : 0,
      totalAspirantesSinValiCorreo : 0,
      porcAspirantesSinValiCorreo: 0,
      totalAspirantesSinPlatica: 0,
      porcAspSinPlatica: 0,
      totalAspirantesConPlatica: 0,
      porcAspConPlatica: 0,
      totalAspAcudenJDE: 0,
      porcAspAcudenJDE: 0,
      totalAspObs: 0,
      porcAspObs: 0,
      totalAspSinDocs: 0,
      totalaspirantesvalidados:0,
      porcaspirantesvalidados:0,
      totalevalcurri:0,
      porcevalcurri:0,
      totalevalint:0,
      porcevalint:0,
      totalaspfinal:0,
      porcaspfinal:0,
      porcSinDocs: 0
    });
  }

  mostrarActividades(){
    mostrar = !mostrar;
    var divItinerario = document.getElementById("div-itinerario");
    var itinerarioMov = document.getElementById("itinerario-mov");
    var tituloActividades = document.getElementById("titulo_actividades");

    if(mostrar){
      divItinerario.style.display ="block";
      itinerarioMov.style.height = "100%";
      tituloActividades.style.float = "right";
    }else{
      divItinerario.style.display ="none";
      itinerarioMov.style.height = "";
      itinerarioMov.style.width = "";
      tituloActividades.style.float = "";
    }
  }

  render(){
    const { rolUsuario, distrito, proceso, estado, user } = this.props;
    const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
    const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
    var idEstado = estado ? estado.idEstado : 0;
    var idDistrito = distrito ? distrito.idDistrito : 0;
    const participa = estado ? true : false;

    // Si el usuario trae idEstado, lo usamos
    if(user.idEstado > 0)
      idEstado = user.idEstado;

    if(user.idDistrito > 0)
      idDistrito = user.idDistrito;

    if(window.location.pathname !== '/menuJDE'){
      return null;
    }

    if(idProcesoElectoral > 0 && idDetalleProceso > 0){
      return(

        <BlockLoader  blocking={this.state.loader}>
              <div id="toPDF">
              <Modal
                className="modalError"
                title={<img  src={errorImgModal} id="img-error-modal"/>}
                centered
                onCancel={()=>this.cerrarErrorModal()}
                visible={this.state.abrirModalError}
                footer={false}
                width={400}
              >
                {this.state.msjError}
              </Modal>
              <Row gutter={16} >
                <Col xs={24} sm={24} md={24} lg={24}>
        {/*           <div id="seccion-exportar"
                    className={rolUsuario !== "JD" ? "exportarSeccion" : "seccionExportar"}> */}
                  <div id="seccion-exportar-cedula">
                    <Dropdown overlay={this.menuBitacoras}  trigger={['click']}>
                      <Button style={{marginRight:'10px', marginBottom:'10px'}}>
                          Descarga de bitácoras<Icon type="down"/>
                      </Button>
                    </Dropdown> 

                    <Dropdown overlay={this.menu}  trigger={['click']}>
                        <Button>
                          Descarga cédula<Icon type="down"/>
                      </Button>
                      </Dropdown>
                  </div>
                </Col>
              </Row>
              <Row id="itinerario-mov" className={rolUsuario === "OC" ? "itinerarioOc" : ""}>
                <Col xs={12} sm={12} md={12} lg={12} id="div-itinerario">
                  <Row id="flecha2-mov" className="actividades_mov">
                    <Col xs={6} sm={6} md={6} lg={6}>
                      <img src={flecha2} className="flecha_img"/>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6}>
                      <div className="div_fecha_act">
                        <p className="fecha_mov">{this.state.actividades !== null && this.state.actividades.length >= 1 ? this.state.actividades[0].periodo : ""}</p>
                        <p className="actividad_mov">{this.state.actividades !== null && this.state.actividades.length >= 1 ?this.state.actividades[0].nombreActividad : ""}</p>
                      </div>
                    </Col>
                  </Row>
                  <Row id="flecha3-mov" className="actividades_mov">
                    <Col xs={6} sm={6} md={6} lg={6}>
                      <img src={flecha3} className="flecha_img"/>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6}>
                      <div className="div_fecha_act">
                        <p className="fecha_mov">{this.state.actividades !== null && this.state.actividades.length >= 2 ? this.state.actividades[1].periodo : ""}</p>
                        <p className="actividad_mov">{ this.state.actividades !== null && this.state.actividades.length >= 2 ? this.state.actividades[1].nombreActividad : ""}</p>
                      </div>
                    </Col>
                  </Row>
                  <Row id="flecha4-mov" className="actividades_mov">
                    <Col xs={6} sm={6} md={6} lg={6}>
                      <img src={flecha4} className="flecha_img"/>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6}>
                      <div className="div_fecha_act">
                        <p className="fecha_mov">{this.state.actividades !== null && this.state.actividades.length >= 3 ? this.state.actividades[2].periodo : ""} </p>
                        <p className="actividad_mov">{this.state.actividades !== null && this.state.actividades.length >= 3 ? this.state.actividades[2].nombreActividad : ""}</p>
                      </div>
                    </Col>
                  </Row>
                  <Row id="flecha5-mov" className="actividades_mov">
                    <Col xs={6} sm={6} md={6} lg={6}>
                      <img src={flecha5} className="flecha_img"/>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6}>
                      <div className="div_fecha_act">
                        <p className="fecha_mov">{this.state.actividades !== null && this.state.actividades.length >= 4 ?this.state.actividades[3].periodo : ""}</p>
                        <p className="actividad_mov">{this.state.actividades !== null && this.state.actividades.length >= 4 ?this.state.actividades[3].nombreActividad : ""}</p>
                      </div>
                    </Col>
                  </Row>
                  <Row id="flecha6-mov" className="actividades_mov">
                    <Col xs={6} sm={6} md={6} lg={6}>
                      <img src={flecha6} className="flecha_img"/>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6}>
                      <div className="div_fecha_act">
                        <p className="fecha_mov">{this.state.actividades !== null && this.state.actividades.length >= 5 ? this.state.actividades[4].periodo : ""}</p>
                        <p className="actividad_mov">{this.state.actividades !== null && this.state.actividades.length >= 5 ? this.state.actividades[4].nombreActividad : ""}</p>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <div id="titulo_actividades" >
                    <Button onClick={this.mostrarActividades}>Actividades</Button>
                  </div>
                </Col>
              </Row>
              <Row gutter={16} id="barra-totales">
                <Col sm={24} md={24} lg={24}>
                  {/* <div id={idDistrito > 0 || rolUsuario === "JD" ? "etiqueta-gral-comp" : "etiqueta-gral"} */}
                  <div id="etiqueta-gral-comp"
                        >
                    <Row gutter={16}>
                      <Col xs={12} sm={12} md={12} lg={12} id="etiqueta-total-asp">
                          <p id="titulo_gral">
                            Total de aspirantes
                          </p>
                          <p id="entidad" className={entidad != "" ? "entidadVerde" : "entidadNegro"}>
                                {entidad != "" ? entidad : "registrados"}
                          </p>
        
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={12} id="total-gral-comp">
                        <div id="total-aspirantes">
                          <p id="total-gral">
                           { new Intl.NumberFormat('en-US', { style: 'decimal', currency: 'USD' }
                          ).format(this.state.totalAspirantes)}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <div id="barra-circular" className="barraCircular">
                <Row gutter={16} className="grafica_circulo" >
                    <Col  sm={24} md={12} lg={8}
                         className="circ-linea" id="circulo-izq">
                    <Tooltip title={"Registros en línea "+this.state.totalRegLinea}
                              placement="top">
                      <div>
                        <Progress type="circle" percent={this.state.porcRegLinea}
                                  strokeColor={'#8140a1'} showInfo={false} strokeWidth={15}/>
                      </div>
                    </Tooltip>
                    <div className={idDistrito > 0 || rolUsuario === "JD" ? "info_circ_lin" : "text_info_circ_lin"}>
                       <p className="titulo_centro">
                          En l&iacute;nea
                       </p>
                       <p className="titulo_total">
                          {this.state.porcRegLinea}%
                       </p>
        
                    </div>
                  </Col>
                  <Col sm={24} md={12} lg={8}
                       className="circ-linea" id="circulo-der">
                    <Tooltip title={"Registros en JDE "+this.state.totalRegJd}
                              placement="top">
                    <div>
                      <Progress type="circle" percent={this.state.porcRegJd}
                                strokeColor={'#409aa1'} showInfo={false} strokeWidth={15}/>
                    </div>
                  </Tooltip>
                    <div className={idDistrito > 0 || rolUsuario === "JD" ? "info_circ_lin" : "text_info_circ_lin"}>
                      <p className="titulo_centro">
                          En la JDE
                     </p>
                     <p className="titulo_total">
                         {this.state.porcRegJd}%
                     </p>
                    </div>
                  </Col>
                  <Col sm={24} md={24} lg={8} >
                    <div id="bars-mov">
                      <p id="titulo-porc-avance">PORCENTAJE DE AVANCE</p>
                      <label className="etiqueta_avances">
                        Aspirantes sin validar correo
                      </label>
                      <Tooltip title={this.state.totalAspirantesSinValiCorreo+" aspirantes"}
                                placement="top">
                         <Progress percent={this.state.porcAspirantesSinValiCorreo} className="barra_mov"
                                   status="active"/>
                          </Tooltip> 
        
                      <label className="etiqueta_avances">
                        Aspirantes sin documentos, con correo validado y que no acuden a la JDE
                      </label>
                      <Tooltip title={this.state.totalAspSinDocs+" aspirantes"}
                                placement="top">
                         <Progress percent={this.state.porcSinDocs} className="barra_mov"
                                   status="active"/>
                        </Tooltip> 
                      
                      <label className="etiqueta_avances">
                        Aspirantes que acuden a la JDE
                      </label>
                      <Tooltip title={this.state.totalAspAcudenJDE+" aspirantes"}
                                placement="top">
                         <Progress percent={this.state.porcAspAcudenJDE} className="barra_mov"
                                 status="active"/>
                      </Tooltip>
                      
                      <label className="etiqueta_avances">
                        Aspirantes con documentos adjuntos por validar
                      </label>
                      <Tooltip title={this.state.totalAspDocPorApro+" aspirantes"}
                                placement="top">
                        <Progress percent={this.state.porcAspDocPorApro} className="barra_mov"
                               status="active"/>
                      </Tooltip>
        
                      <label className="etiqueta_avances">
                        Aspirantes con documentos con observaciones
                      </label>
                      <Tooltip title={this.state.totalAspObs+" aspirantes"}
                                placement="top">
                         <Progress percent={this.state.porcAspObs} className="barra_mov"
                                   status="active"/>
                      </Tooltip>
        
                      <label className="etiqueta_avances">
                        Aspirantes declinados
                      </label>
                      <Tooltip title={this.state.totalRegDeclinados+" aspirantes"}
                                placement="top">
                         <Progress percent={this.state.porcRegDeclinados} className="barra_mov"
                                 status="active"/>
                      </Tooltip>
        
                      <label className="etiqueta_avances">
                        Aspirantes finalizados sin cápsula de inducción
                      </label>
                      <Tooltip title={this.state.totalAspirantesSinPlatica+" aspirantes"}
                                placement="top">
                        <Progress percent={this.state.porcAspSinPlatica} className="barra_mov"
                                  status="active"/>
                    </Tooltip>
        
        
                      <label className="etiqueta_avances">
                        Aspirantes finalizados con cápsula de inducción
                      </label>
                      <Tooltip title={this.state.totalAspirantesConPlatica+" aspirantes"}
                                placement="top">
                        <Progress percent={this.state.porcAspConPlatica} className="barra_mov"
                                  status="active"/>
                      </Tooltip>      
                       
                   </div>
                  </Col>
                </Row>
              </div>
              <Row id="itinerario">
                <Col  sm={4} md={4}>
                  <div id="flecha1" className="actividades">
                    <p>Actividades</p>
                  </div>
                </Col>
                {  this.state.actividades !== null && this.state.actividades.length > 0 ?
                  this.state.actividades.map((actividad)=>
                    <Col  sm={4} md={4}>
                      <div className="actividades">
        
                          <p className ="fecha">
                             {actividad.periodo}</p>
        
                        <p className="actividad">{actividad.nombreActividad}</p>
                      </div>
                    </Col> 
                  ):""
                }
              </Row>
            </div></BlockLoader>
          )
    } else {
      return (
        <div>
          <Mapa participa={participa} idEstado={idEstado} idDistrito={idDistrito} totalAspirantes={this.state.totalAspirantes} totalRegLinea={this.state.totalRegLinea} totalRegJd={this.state.totalRegJd} />
        </div>
      )
    }

  }
};

const mapStateToProps = createStructuredSelector({
  estado: selectEstado,
  proceso: selectProceso,
  distrito: selectDistrito,
  user: selectCurrentUser,
  rolUsuario: selectCurrentUserRol
});

export default withRouter(connect(mapStateToProps, null)(Filtros));